// extracted by mini-css-extract-plugin
export var additional = "modal-success-module--additional--K4+Cf";
export var animateCircle = "modal-success-module--animate-circle--rTdmE";
export var bounce = "modal-success-module--bounce--KHAaC";
export var button = "modal-success-module--button--8rN7n";
export var close = "modal-success-module--close--nv0TZ";
export var container = "modal-success-module--container--6qYvs";
export var cross = "modal-success-module--cross--TyO0-";
export var description = "modal-success-module--description--z9-MU";
export var ldsRing = "modal-success-module--lds-ring--24iGh";
export var popup = "modal-success-module--popup--a2GtA";
export var subtitle = "modal-success-module--subtitle--sg+h4";
export var subtitleMd = "modal-success-module--subtitleMd--z5f7N";
export var thanks = "modal-success-module--thanks--gGPRr";
export var title = "modal-success-module--title--r1TXB";